export default __webpack_public_path__ + "static/media/notif_article_news_published.4984c013.svg";